export const EvaluationInfoEnum = {
EvaluationStepInfo: "EvaluationStepInfo",
EvaluationInfo: "EvaluationInfo",
ourLawInfo: "ourLawInfo",
otherRequirementInfo: "otherRequirementInfo",
updateConnectionInfo: "updateConnectionInfo",
OurLawCheckListInfo:"OurLawCheckListInfo",
OtherRequirementCheckListInfo:"OtherRequirementCheckListInfo",
OtherRequirementupdateConnectionInfo:"otherRequirementupdateConnectionInfo"
};

export const EvaluationInfoType = Object.values(EvaluationInfoEnum);